import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';

const CallbackHandler = () => {
  const { isLoading, error } = useAuth0();

  if (isLoading) {
    return <div>loading</div>;

    if (error) {
      return (
        <div className="error-container">
          <h2>Authentication Error</h2>
          <p>{error?.message}</p>
          <button onClick={() => (window.location.href = '/')}>Return Home</button>
        </div>
      );
    }
  }
  return <Navigate to="/" replace />;
};
export default CallbackHandler;
